import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import { BTDatePickerDate } from "commonComponents/btWrappers/BTDatePicker/BTDatePickerDate";
import { type IGridCellRendererParams } from "commonComponents/utilities/AgGridReact/AgGridReact.types";
import { DateDisplayDate } from "commonComponents/utilities/DateDisplay/DateDisplayDate";

function columnDateInternal(props: IGridCellRendererParams) {
    if (props.node.group) {
        return null;
    } else if (props.value) {
        return (
            <DateDisplayDate
                data-testid="ag-col-date"
                value={props.value instanceof Date ? props.value : new Date(props.value)}
                className={cn("ag-col-date", props.className)}
            />
        );
    } else {
        return null;
    }
}

function columnDateEditInternal(props: IGridCellRendererParams) {
    if (props.node.group) {
        return <>{props.value}</>;
    } else if (props.value) {
        return (
            <BTDatePickerDate
                id={`ag-col-date-editor.${props.colDef!.field!}.${props.node.rowIndex!}`}
                data-testid="ag-col-date-editor"
                value={props.value}
                onChange={() => {}}
                className={cn("ag-col-date-editor", props.className)}
            />
        );
    }
    return null;
}

export const columnDate = memo(columnDateInternal);
export const columnDateEdit = memo(columnDateEditInternal);
